import { render, staticRenderFns } from "./manageUserPermission.vue?vue&type=template&id=1338c53e&scoped=true&"
import script from "./manageUserPermission.vue?vue&type=script&lang=js&"
export * from "./manageUserPermission.vue?vue&type=script&lang=js&"
import style0 from "./manageUserPermission.vue?vue&type=style&index=0&id=1338c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338c53e",
  null
  
)

export default component.exports